export default __webpack_public_path__ + "static/media/product-overview-bg.d57972da.webp";